import { createBaseResourceActions } from '../create-base-resource-actions';
import { ActionLogResourceTypeMappings } from '@aa/nest/resource';

const domainSlug = '[ACTION LOG]';
export const actionLogActions =
  createBaseResourceActions<ActionLogResourceTypeMappings>(domainSlug);
